/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Events_Ordered_By_TimeInputs */

const en_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Events ordered by time successfully`)
};

const fr_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements triés par temps avec succès`)
};

const de_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignisse erfolgreich nach Zeit sortiert`)
};

const it_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi ordinati correttamente in base al tempo`)
};

const ru_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События успешно упорядочены по времени.`)
};

const es_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos ordenados por tiempo con éxito`)
};

const zh_cn2_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按时间排序的事件成功`)
};

const ja_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントは時間順に並べられました`)
};

const hi_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`समय के अनुसार क्रमबद्ध की गई घटनाएँ सफलतापूर्वक`)
};

const pt_pt2_events_ordered_by_time = /** @type {(inputs: Events_Ordered_By_TimeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos ordenados por tempo com sucesso`)
};

/**
* | output |
* | --- |
* | "Events ordered by time successfully" |
*
* @param {Events_Ordered_By_TimeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const events_ordered_by_time = /** @type {((inputs?: Events_Ordered_By_TimeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Events_Ordered_By_TimeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_events_ordered_by_time(inputs)
	if (locale === "de") return de_events_ordered_by_time(inputs)
	if (locale === "it") return it_events_ordered_by_time(inputs)
	if (locale === "ru") return ru_events_ordered_by_time(inputs)
	if (locale === "es") return es_events_ordered_by_time(inputs)
	if (locale === "zh-CN") return zh_cn2_events_ordered_by_time(inputs)
	if (locale === "ja") return ja_events_ordered_by_time(inputs)
	if (locale === "hi") return hi_events_ordered_by_time(inputs)
	if (locale === "pt-PT") return pt_pt2_events_ordered_by_time(inputs)
	return en_events_ordered_by_time(inputs)
});